import { PostPrivacy } from '@wellesley/openapi'
import {
  Earth,
  ListX,
  AtSign,
  LockKeyhole,
  GitPullRequestArrow,
} from 'lucide-react'

const ICON_SIZE = 16
const ICON_COLOR = 'var(--gray-900)'
const ICON_ACTIVE_COLOR = 'var(--blue-500)'

const getFeedPrivacyIcon = (
  privacy: PostPrivacy,
  isActive = false,
  size = ICON_SIZE,
) => {
  const iconColor = isActive ? ICON_ACTIVE_COLOR : ICON_COLOR

  const props = {
    size,
    color: iconColor,
    className: 'cursor-default',
    onClick: (e: React.MouseEvent<SVGElement>) => {
      e.preventDefault()
      e.stopPropagation()
    },
  }

  switch (privacy) {
    case 'UNLISTED':
      return <ListX {...props} />
    case 'DIRECT':
      return <AtSign {...props} />
    case 'PRIVATE':
      return <LockKeyhole {...props} />
    case 'PUBLIC':
      return <Earth {...props} />
    default:
      return <GitPullRequestArrow {...props} />
  }
}

export default getFeedPrivacyIcon
